import axios from 'axios';

// Sito ecommerce → Velocita' del sito: Core Web Vitals dei visitatori veri
const state = {
	summary: null,
};

const getters = {
	getSummary: state => state.summary,
};

const auth = context => ({ headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` } });

const actions = {
	fetchSummary: async (context, { days, device } = {}) => {
		const res = await axios.get(`${context.rootGetters['settings/getUrl']}webvitals/summary`, { ...auth(context), params: { days: days || 7, device: device || undefined } });
		context.commit('setSummary', res.data.data);
		return res.data.data;
	},
	destroyData: context => {
		context.commit('setSummary', null);
	},
};

const mutations = {
	setSummary: (state, value) => {
		state.summary = value;
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};
